import { appSuiteRootPath } from '../../data/constants.ts';
import { utilityStyles } from '../base/utilityStyles.ts';
import styleText from './as-mobile-warning.css?raw';

class AsMobileWarning extends HTMLElement{
  constructor(){
    super();
    this.attachShadow({ mode: 'open' });

    const sheet = new CSSStyleSheet();
    sheet.replace(styleText)
    this.shadowRoot!.adoptedStyleSheets = [sheet,utilityStyles]

    this.shadowRoot.innerHTML = /*html*/`
      <div class="col gap-1rem">
        <as-text class="modal-header">Mobile Detected</as-text>
        <as-text class="modal-body" dict-key="modals.mobile-warning.body">
          Thank you for your interest in the Additive App-Suite!
          
          This app is optimized for desktop use, please return on a suitable device.
        </as-text>
        <as-text-button link="${window.location.origin}">Back to Storefront</as-text-button>
      </div>
    `
  }
}
customElements.define("as-mobile-warning",AsMobileWarning)